var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3392 2.30027C10.3536 1.92938 10.0634 1.61527 9.69243 1.62604C7.91975 1.67752 6.18899 2.17337 4.6804 3.06796C2.98142 4.07544 1.6428 5.54205 0.838532 7.27715C0.0342693 9.01225 -0.198439 10.9356 0.170654 12.7972C0.539748 14.6588 1.49357 16.3725 2.90815 17.7156C4.32273 19.0588 6.13264 19.9692 8.10262 20.3285C10.0726 20.6879 12.1116 20.4795 13.9544 19.7306C15.7973 18.9817 17.3589 17.7268 18.4362 16.129C19.3791 14.7307 19.9129 13.1263 19.9902 11.4786C20.0085 11.088 19.6792 10.7807 19.2883 10.792C18.8955 10.8034 18.5901 11.1324 18.5663 11.5246C18.4826 12.9014 18.0275 14.2395 17.2386 15.4095C16.3142 16.7804 14.9743 17.8572 13.393 18.4998C11.8118 19.1424 10.0623 19.3212 8.37198 19.0128C6.68167 18.7045 5.1287 17.9233 3.91494 16.7709C2.70119 15.6184 1.88277 14.148 1.56607 12.5507C1.24938 10.9534 1.44905 9.30307 2.13914 7.81429C2.82922 6.32551 3.97781 5.06711 5.4356 4.20266C6.70453 3.45019 8.15665 3.0265 9.64628 2.9685C10.015 2.95414 10.3249 2.66896 10.3392 2.30027Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30512 12.4921L17.8768 4.48852C18.1811 4.20437 18.668 4.196 18.9834 4.4695C19.3226 4.76356 19.3314 5.26619 19.0028 5.57033L9.30511 14.5451L5.07875 10.6282C4.79667 10.3668 4.79428 9.9382 5.07343 9.67434C5.343 9.41954 5.77751 9.41155 6.05771 9.65624L9.30512 12.4921Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignMiddle);
export default __webpack_public_path__ + "static/media/sign-middle.dcfcc15fa9beb3cbe3a2a67257d1d0cd.svg";
export { ForwardRef as ReactComponent };